document.addEventListener('DOMContentLoaded', () => {
  // Get map elements
  const maps = document.querySelectorAll('.offices__map');

  function hidePopups(map) {
    const dots = map.querySelectorAll('.office-dot');
    const popups = map.querySelectorAll('.office-popup');

    map.classList.remove('has-popup-open');

    for (let j = 0; j < popups.length; j++) {
      const popup = popups[j];

      popup.setAttribute('aria-hidden', 'true');
    }

    for (let j = 0; j < dots.length; j++) {
      const dot = dots[j];

      dot.setAttribute('aria-pressed', 'false');
    }
  }

  // Clicking an office location dot
  function clickDot(event) {
    event.preventDefault();
    const dot = event.currentTarget; // Get this dot
    const map = dot.closest('.offices__map'); // Get the map this dot is within

    // Get corresponding popup
    id = dot.id;
    const popup = map.querySelector('#' + id + '-popup');

    // Check state of dot
    if (dot.getAttribute('aria-pressed') === 'true') {
      // Hide the popup
      map.classList.remove('has-popup-open');
      popup.setAttribute('aria-hidden', 'true');
      dot.setAttribute('aria-pressed', 'false');
    } else {
      // Hide all popups
      hidePopups(map);

      // Show this popup
      map.classList.add('has-popup-open');
      popup.setAttribute('aria-hidden', 'false');
      dot.setAttribute('aria-pressed', 'true');
      setTimeout(function () {
        popup.focus();
      }, 300);
    }
  }

  function positionPopup(dot, mapSVGBox, popup) {
    // Get transform of this dot
    const dotShape = dot.querySelector('.office-dot__circle');
    transformValue = dot.getAttribute('transform');

    // Split transform into individual values
    /* eslint-disable no-useless-escape */
    const transformNums = transformValue
      .replace('translate(', '')
      .replace(')', '');
    /* eslint-enable no-useless-escape */

    const transformSplit = transformNums.split(' ');

    const transformX = transformSplit[0];
    const transformY = transformSplit[1];

    // Convert dot's width into percentage of svg width/height
    dotHalfWidthPercent = (dotShape.getAttribute('r') / mapSVGBox.width) * 100;
    dotHalfHeightPercent =
      (dotShape.getAttribute('r') / mapSVGBox.height) * 100;

    // Convert transforms into percentages
    xPos = parseFloat(mapSVGBox.x) * -1 + parseFloat(transformX);
    yPos = parseFloat(mapSVGBox.y) * -1 + parseFloat(transformY);
    xPercent = (xPos / mapSVGBox.width) * 100;
    yPercent = (yPos / mapSVGBox.height) * 100;

    // Add half dot's width/height to percent
    xPercent = xPercent + dotHalfWidthPercent;
    yPercent = yPercent + dotHalfHeightPercent;

    // Give the popup the left/top percentage values calculated earlier
    popup.style.setProperty('--left', xPercent + '%');
    popup.style.setProperty('--top', yPercent + '%');

    // calculate width of popup and if it's too close to the left or top, make it line up with a different corner
    // get width and height of popup
    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    // get as percentages of map
    const popupWidthPercent = (popupWidth / mapSVGBox.width) * 100;
    const popupHeightPercent = (popupHeight / mapSVGBox.height) * 100;

    // Check if the popup's width is larger than its left offset
    if (popupWidthPercent > xPercent) {
      // If yes, flip it so it's within bounds
      popup.classList.add('flip-x');
    }

    // Check if the popup's height is larger than its top offset
    if (popupHeightPercent > yPercent) {
      // If yes, flip it so it's within bounds
      popup.classList.add('flip-y');
    }
  }

  function clickMap(event) {
    const map = event.currentTarget.closest('.offices__map'); // Get this map

    // Only if an office dot wasn't clicked
    if (
      !(
        event.target.classList.contains('office-dot') ||
        event.target.parentNode.classList.contains('office-dot')
      ) &&
      map.classList.contains('has-popup-open')
    ) {
      hidePopups(map);
    }
  }

  if (maps) {
    // For each map...
    for (let i = 0; i < maps.length; i++) {
      const map = maps[i];

      // Get viewbox of svg to do maths with
      const mapSVG = map.querySelector('.offices__map-svg');
      const mapSVGBox = mapSVG.viewBox.baseVal;

      // Get all the popups
      const popups = map.querySelector('.offices__popups');

      // Get all office dots in this map
      const dots = map.querySelectorAll('.office-dot');

      // Dismiss all popups on map clicl
      mapSVG.addEventListener('click', clickMap);

      // For each dot
      for (let j = 0; j < dots.length; j++) {
        const dot = dots[j];

        // Get corresponding popup
        id = dot.id;
        const popup = popups.querySelector('#' + id + '-popup');

        // Position the popup on the dot
        positionPopup(dot, mapSVGBox, popup);

        // Show the popup on click
        dot.addEventListener('click', clickDot);
      }

      // Signify the map is set up
      map.classList.add('ready');
    }
  }
});
